import { combineReducers } from "redux";
import authReducer from "./Auth/reducers";
import saleReducer from "./Transaction/reducers";
import paymentReducer from "./payment/reducers";
import vendorsReducer from "./vendors/reducers";
import loanTypeReducer from "./Loan-type/reducers";
import loanReducer from "./Loan/reducers";
import assetsReducer from "./Assets/reducers";
import transfersReducer from "./Transfers/reducers";

const rootReducer = combineReducers({
  Auth: authReducer,
  Sale: saleReducer,
  Payment: paymentReducer,
  Vendors: vendorsReducer,
  LoanType: loanTypeReducer,
  Loan: loanReducer,
  Assets: assetsReducer,
  Transfer: transfersReducer,
});

export default rootReducer;
